import React, { useEffect, useRef } from "react";

// Canvas-based ember/spark particle field for hero + section backgrounds
export default function Embers({ density = 60, className = "" }) {
  const ref = useRef(null);
  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let raf; let particles = [];
    const dpr = Math.min(window.devicePixelRatio || 1, 2);

    const resize = () => {
      const { clientWidth: w, clientHeight: h } = canvas.parentElement;
      canvas.width = w * dpr; canvas.height = h * dpr;
      canvas.style.width = w + "px"; canvas.style.height = h + "px";
    };
    resize();
    window.addEventListener("resize", resize);

    const spawn = (x, y) => ({
      x: x ?? Math.random() * canvas.width,
      y: y ?? canvas.height + Math.random() * 40,
      vx: (Math.random() - 0.5) * 0.15 * dpr,
      vy: -(Math.random() * 0.7 + 0.25) * dpr,
      r: (Math.random() * 1.6 + 0.4) * dpr,
      life: 0,
      max: Math.random() * 260 + 140,
      hue: 20 + Math.random() * 20
    });

    for (let i = 0; i < density; i++) particles.push(spawn(Math.random() * canvas.width, Math.random() * canvas.height));

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach((p, i) => {
        p.x += p.vx; p.y += p.vy; p.life++;
        const a = Math.max(0, 1 - p.life / p.max);
        const grad = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 6);
        grad.addColorStop(0, `hsla(${p.hue}, 90%, 62%, ${0.9 * a})`);
        grad.addColorStop(0.4, `hsla(${p.hue}, 85%, 50%, ${0.35 * a})`);
        grad.addColorStop(1, "hsla(20,85%,50%,0)");
        ctx.fillStyle = grad;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r * 6, 0, Math.PI * 2); ctx.fill();
        ctx.fillStyle = `hsla(${p.hue}, 100%, 85%, ${a})`;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2); ctx.fill();
        if (p.life > p.max || p.y < -20) particles[i] = spawn();
      });
      raf = requestAnimationFrame(draw);
    };
    draw();
    return () => { cancelAnimationFrame(raf); window.removeEventListener("resize", resize); };
  }, [density]);

  return <canvas ref={ref} className={`absolute inset-0 pointer-events-none ${className}`} />;
}
